module.exports = __webpack_public_path__ + "static/media/about-marburg-poster-1.1bb90673.png";